'use strict';

// modules
require('./_modules/countDown');
require('./_modules/eqHeight');
require('./_modules/accordion');

$('.js-countdown').each(function(){
  new CountDown().init($(this));
});

$('.js-height').each(function(){
  new EqHeight().init($(this));
});

$('.js-accordion-trigger').each(function(){
  var $parent = $(this).closest('.js-accordion');
  new Accordion().init($(this), $parent);
});


//////////////////
// WEBPACK FOOTER
// ./js/common.js
// module id = 0
// module chunks = 0